module.exports = __webpack_public_path__ + "static/media/emoji-svgrepo-com (1).cc841697.svg";